import { render, staticRenderFns } from "./UpgraderGame.vue?vue&type=template&id=709e6d64&scoped=true"
import script from "./UpgraderGame.vue?vue&type=script&lang=js"
export * from "./UpgraderGame.vue?vue&type=script&lang=js"
import style0 from "./UpgraderGame.vue?vue&type=style&index=0&id=709e6d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e6d64",
  null
  
)

export default component.exports